export default {
  choose_preferred_wallet: "选择你的钱包",
  connect_mobile_wallet: "连接至移动端钱包",
  scan_qrcode_with_wallet: "使用兼容 WalletConnect 的钱包扫描二维码",
  return_to_mobile_options: "回到移动端钱包选项",
  view_qrcode_option: "查看二维码",
  connect: "连接",
};
